import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../Constant";

// Thunk functions
export const getTrack = createAsyncThunk(
  "track/get",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${baseURL}/track-details`);
      return response.data; // Return data for fulfilled action
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const toggleTrack = createAsyncThunk(
  "track/toggle",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.patch(`${baseURL}/track-details`, payload);
      if (response.status === 200) {
        return payload; // Return data for fulfilled action
      }
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const TrackSlice = createSlice({
  name: "track",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    set: (state, { payload }) => {
      state.data = payload;
      state.loading= false;
    },
    add: (state, { payload }) => {
      state.data.push(payload);
      state.loading= false;
    },
    toggle: (state, { payload }) => {
      const track = state.data.find((track) => track.id === payload.trackId);
      if (track) {
        track.isActive = payload.newisActiveval;
      }
      state.loading= false;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload; // Manually set loading state
    },
  },
  extraReducers: (builder) => {
    builder
      // getTrack
      .addCase(getTrack.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTrack.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.data = payload;
      })
      .addCase(getTrack.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      // toggleTrack
      .addCase(toggleTrack.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(toggleTrack.fulfilled, (state, { payload }) => {
        state.loading = false;
        const track = state.data.find((track) => track.id === payload.trackId);
        if (track) {
          track.isActive = payload.newisActiveval;
        }
      })
      .addCase(toggleTrack.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export const { add, set, toggle, setLoading} = TrackSlice.actions;
export default TrackSlice.reducer;
